import React from 'react';
import { toPostUI } from '../../mappers/posts/toPostUI';
import { Box } from '../../ui/layout/Box';
import { Flex } from '../../ui/layout/Flex';
import { InfiniteGrid } from '../../ui/layout/InfiniteGrid';
import { PostCardCompact, PostCardCompactSkeleton } from '../../ui/posts/PostCardCompact';
import { Typography } from '../../ui/typography/Typography';
import { UsePostsCollectionPayload } from '../post/usePostCollection';

const PER_PAGE = 24;

interface SearchPostProps {
    postCollection: UsePostsCollectionPayload;
}

export const SearchPost = (props: SearchPostProps) => {
    const { postCollection } = props;

    return postCollection.isLoading || postCollection.items.length > 0 ? (
        <InfiniteGrid
            columns={3}
            perPage={PER_PAGE}
            count={postCollection.items.length}
            isLoading={postCollection.isLoading}
            isEndReached={postCollection.isEndReached}
            onLoadNext={postCollection.onLoadNext}
            renderItem={(index: number) => {
                const postModel = postCollection.items[index];

                if (postModel) {
                    return (
                        <Box>
                            <PostCardCompact post={toPostUI(postModel)} />
                        </Box>
                    );
                }

                if (postCollection.isLoading) {
                    return (
                        <Box>
                            <PostCardCompactSkeleton />
                        </Box>
                    );
                }

                return null;
            }}
        />
    ) : (
        <Flex px={3} alignItems="flex-start" justifyContent="center" flexGrow={1} spacing={1}>
            <Typography variant="title2" weight="bold">
                Ничего не найдено
            </Typography>
            <Typography>
                Попробуйте другой запрос. <br />
                Например «Кроссовки» или «Путешествия»
            </Typography>
        </Flex>
    );
};
